import './styles/styles.scss';

import Highway from '@dogstudio/highway/src/highway';
import 'picturefill/dist/picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
import Glide from '@glidejs/glide';
import CustomRenderer from './renderer.js';
import Fade from './fade.js';

lazySizes.cfg.expand = 300;
lazySizes.cfg.expFactor = 1.25;
lazySizes.init();

const root = document.getElementsByTagName('html')[0];
const body = document.getElementsByTagName('body')[0];
let wrapper = document.querySelector('.wrapper');
let navBurger = document.querySelector('.navbar-burger');
let navBar = document.querySelector('.navbar');
let navMenu = document.querySelector('.navbar-menu');
let main = document.getElementsByTagName('main')[0];
let footer = document.querySelector('footer');
let scrollTopBtn = document.querySelector('#scrolltop');

let ww = window.innerWidth,
    wh = window.innerHeight;

let pageIn;
let pageOut;
let activeMenuItem;
let pageCurrent = wrapper.firstElementChild.getAttribute('data-router-view');
let pageName = main.firstElementChild.getAttribute('id');
console.log('pageName', pageName);

gsap.set(wrapper, { paddingTop: navBar.offsetHeight + 10 });
// gsap.set(wrapper, { paddingBottom: footer.offsetHeight });
if (pageName !== 'projekte') {
    gsap.set(main.firstElementChild, { minHeight: wh - navBar.offsetHeight - footer.offsetHeight });
}

const H = new Highway.Core({
    renderers: {
        name: CustomRenderer
    },
    transitions: {
        default: Fade,
    }
});

H.on('NAVIGATE_OUT', ({ from }) => {
    pageOut = from.view;
    // pageCurrent = pageOut.getAttribute('data-router-view');
    activeMenuItem = document.querySelector('.navbar-item.is-active');
    typeof(activeMenuItem) != 'undefined' && activeMenuItem != null ? activeMenuItem.classList.remove('is-active') : null;
    if (navMenu.classList.contains('is-active')) {
        root.classList.remove('is-clipped');
        body.classList.remove('is-clipped');
        navMenu.classList.remove('is-active');
        navBar.classList.remove('is-active');
        navBurger.classList.remove('is-active');
    }
    if (ww >= 768) {

    } else {

    }
});

H.on('NAVIGATE_IN', ({ to, trigger, location }) => {
    pageIn = to.view;
    pageCurrent = pageIn.getAttribute('data-router-view');
    pageName = pageIn.firstElementChild.getAttribute('id');
    gsap.set(wrapper, { paddingTop: navBar.offsetHeight + 10 });
    gsap.set(pageIn.firstElementChild, { minHeight: wh - navBar.offsetHeight - footer.offsetHeight });
    // if (pageName !== 'publications') {}
    // if (ww >= 960) {
    //     activeMenuItem = document.querySelector('.item-' + pageName);
    //     typeof(activeMenuItem) != 'undefined' && activeMenuItem != null ? activeMenuItem.classList.add('is-active') : null;
    // }
});

H.on('NAVIGATE_END', ({ to, trigger, location }) => {
    pageIn = to.view;
    pageCurrent = pageIn.getAttribute('data-router-view');
    pageName = pageIn.firstElementChild.getAttribute('id');
    // postContent = pageIn.querySelector('.post-content');
    console.log('pageName', pageName);

    if (pageName === 'publications') {
        ajaxloadmore.start(document.querySelector('.ajax-load-more-wrap'));
        window.almComplete = function(alm) {
            console.log(alm);
        }
    }
});

function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

var hash = window.location.hash;
if (hash !== '') {
    // console.log('hash', hash);
    gsap.to(window, {
        duration: 1,
        scrollTo: {
            y: hash,
            offsetY: navBar.offsetHeight + 50
                // (ww > 768 ? navbarMenu.offsetHeight : navbar.offsetHeight) + (ww >= 1920 ? 99 : (ww > 768 ? 24 : -1)) //-navbarMenu.offsetHeight-1
        },
        ease: 'power2',
        onComplete: () => {
            // document.querySelector(hash + ' .collapse-button').click();
        }
    });
}

navBurger.onclick = function(e) {
    e.preventDefault();
    root.classList.toggle('is-clipped');
    body.classList.toggle('is-clipped');
    navMenu.classList.toggle('is-active');
    navBar.classList.toggle('is-active');
    navBurger.classList.toggle('is-active');
    // if (navBurger.classList.contains('has-text-white')) {
    //     // navBurger.classList.remove('has-text-white');
    //     // navBurger.classList.add('has-text-bluedark');
    // } else {
    //     navBurger.classList.contains('is-active') ? navBurger.classList.add('has-text-white') : 
    // }
    // if (logo.querySelector('#logo').classList.contains('has-text-white')) {
    //     // logo.querySelector('#logo').classList.remove('has-text-white');
    //     // logo.querySelector('#logo').classList.add('has-text-bluedark');
    // } else {
    //     logo.querySelector('#logo').classList.remove('has-text-bluedark', 'has-text-primary');
    //     logo.querySelector('#logo').classList.add('has-text-white');
    // }
    // gsap.to(search, { height: wh - navbar.offsetHeight });
    // gsap.to(search, { height: navbar.classList.contains('is-scrolled') ? wh - navbar.offsetHeight : wh - navbar.offsetHeight - largeHeader.offsetHeight });
};


// function almFilter(el) {
//     var data;
//     var transition = 'fade';
//     var speed = 500;
//     var filter = el;
//     let filterActive = document.querySelector('.is-filter.is-hovered');
//     if (typeof(filterActive) != 'undefined' && filterActive != null) {
//         filterActive.classList.remove('is-hovered');
//     }
//     if (typeof(filter) != 'undefined' && filter != null) {
//         data = filter.dataset; //filter.classList.contains('is-active') ? document.querySelector('.is-filter.allitems').dataset : 
//         console.log('filter data ', data);
//         filter.classList.add('is-hovered');
//         // gsap.to(menu, {
//         //     opacity: 0,
//         //     duration: .2,
//         //     // ease: 'power3.easeOut',
//         //     onComplete: () => {
//         //         filterActive = document.querySelector('.is-filter.is-active');
//         //         if (typeof(filterActive) != 'undefined' && filterActive != null) {
//         //             filterActive.classList.remove('is-active');
//         //             // gsap.to(navbtn, { duration: 0, text: 'Navigate', ease: 'Power0.easeNone' });
//         //         }
//         //         if (searchCheck === false) {
//         //             filter.classList.add('is-active');
//         //         } else {
//         //             gsap.to(navbtn, { duration: 0, text: navigateBtnText, ease: 'Power0.easeNone' });
//         //         }
//         //         menu.classList.contains('is-active') ? gsap.set(menu, { zIndex: 0 }) : null;
//         //         navbtn.classList.toggle('is-active');
//         //         menu.classList.toggle('is-active');
//         //     }
//         // });
//         alm_is_animating = true;
//         ajaxloadmore.filter(transition, speed, data);
//     }
// }

// function filterButtons()  {
//     var filter_buttons = document.querySelectorAll('.is-filter');
//     if (filter_buttons) {
//         [].forEach.call(filter_buttons, function(button) {
//             button.addEventListener('click', function(e) {
//                 var filter = this;
//                 console.log('filter ', filter);
//                 almFilter(filter);
//             });
//         });
//     }
// }

// window.almFilterComplete = function() {
//     alm_is_animating = false;
//     // gsap.to(window, {
//     //     duration: .5,
//     //     scrollTo: { y: 0 }
//     // });
// }

// ALM Callbacks
// window.almComplete = function(alm) {
//     console.log(alm);
//     if (alm.id === 'erklaervideos') {
//         modalPosts();
//     }
// }

// scrollTopBtn.addEventListener('click', function(e) {
//     e.preventDefault();
//     gsap.to(window, {
//         duration: 1,
//         scrollTo: {
//             y: '#top',
//             autoKill: true
//         },
//         ease: 'power2'
//     });
// });

function windowResize() {
    ww = window.innerWidth;
    wh = window.innerHeight;
    // console.log('RESIZED: ww:', ww, ' | wh:', wh);
}

window.addEventListener('resize', windowResize);